import { render, staticRenderFns } from "./LED.vue?vue&type=template&id=004e1da3&"
import script from "./LED.vue?vue&type=script&lang=js&"
export * from "./LED.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VDataTable } from 'vuetify/lib/components/VDataTable';
installComponents(component, {VDataTable})


/* hot reload */
if (module.hot) {
  var api = require("/home/gitlab-runner/builds/-36BVGaF/0/applicationg/aims-dashboard/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('004e1da3')) {
      api.createRecord('004e1da3', component.options)
    } else {
      api.reload('004e1da3', component.options)
    }
    module.hot.accept("./LED.vue?vue&type=template&id=004e1da3&", function () {
      api.rerender('004e1da3', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/Multifunction/LED.vue"
export default component.exports